/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { cn } from '@/lib/utils';

export const StepHeader = ({ n, icon: Icon, title, subtitle, done }) => (
  <div className="flex items-center gap-3">
    <div className={cn('h-9 w-9 rounded-xl flex items-center justify-center font-display font-bold text-sm flex-shrink-0 transition-colors', done ? 'bg-success text-success-foreground' : 'bg-primary/10 text-primary')}>{done ? '✓' : n}</div>
    <div className="min-w-0">
      <div className="font-display font-semibold flex items-center gap-2"><Icon className="h-4 w-4 text-primary" /> {title}</div>
      {subtitle && <div className="text-xs text-muted-foreground">{subtitle}</div>}
    </div>
  </div>
);
